module.exports = __webpack_public_path__ + "img/fantan icon 1.9e41f60b.png";